<template lang="pug">
  div.body.body-table.medical-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent.self="letSearch")
              input(type="search" placeholder="" v-model="searchModel")
            div.parameters
              e-year-selector(year="year")

            div.actions-panel
              e-button-add(@click="addNewRowToMedicalTable()")
              // button(v-if="role!=='guest'" type="button" @click="addNewRowToMedicalTable()").actions-panel__button.btn-add.green

      div(v-if="operationType === 'detail'")
          e-table-editable(
            ref="detail"
            :attributes="garbageDetailAttr"
            :dataUrl="garbageDataUrl"
            :postUrl="garbagePostUrl"
            :patchUrl="garbagePatchUrl"
            :deleteUrl="garbageDeleteUrl"
            :enableOnAdd="enableOnAdd"
            :tableInOnlineMode="tableInOnlineMode"
            :afterFetchData="afterFetchData"
            @sortByField="onSortByField"
            :enablePagination="false"
            @paginate="onPaginate"
          )

      div(v-if="operationType === 'input'")
          e-table-editable(
            ref="input"
            :attributes="garbageInputAttr"
            :dataUrl="garbageDataUrl"
            :postUrl="garbagePostUrl"
            :patchUrl="garbagePatchUrl"
            :deleteUrl="garbageDeleteUrl"
            :enableOnAdd="enableOnAdd"
            :tableInOnlineMode="tableInOnlineMode"
            :afterFetchData="afterFetchData"
          )

      div(v-if="operationType === 'output'")
          e-table-editable(
            ref="output"
            :attributes="garbageOutputAttr"
            :dataUrl="garbageDataUrl"
            :postUrl="garbagePostUrl"
            :patchUrl="garbagePatchUrl"
            :deleteUrl="garbageDeleteUrl"
            :enableOnAdd="enableOnAdd"
            :tableInOnlineMode="tableInOnlineMode"
            :afterFetchData="afterFetchData"

          )
</template>

<script>
  import {garbage, core} from '../../../api/api-endpoints.js'
  import {garbageOffline} from '../../../api/api-offline-endpoints.js'
  import year from  '../../../utils/year.js'
  import {cadastr} from "../../../api/api-endpoints";

  export default {
    name: 'medical-table',
    props: {
      tabView: null,
      id: null
    },
    data () {
      return {
        operationType: null,
        openSelect: false,
        year: year.getCurrentYear(),
        search: '',
        searchModel: '',
        paginationQuery: null
      }
    },
    computed: {
      selectListOptions () {
        return [
          {
            id: 'detail',
            name: 'Движение отходов'
          },
          {
            id: 'input',
            name: 'Сведения о полученных отходах'
          },
          {
            id: 'output',
            name: 'Сведения о переданных отходах'
          }
        ]
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      enableOnAdd () {
        return ['morph_composition', 'med_garbage_class_id']
      },
      garbageDetailSummaryColumns () {
        return ['formed', 'utilization', 'neutralization', 'burial', 'storage', 'processed', 'destroyed']
      },
      garbageInputAttr () {
        return {
          // nobody knows why this field was made
          /* garbageSourceName: {
            label: 'Источник',
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название',
            suggestion: {
              options: [],
              onSelect: this.onSelectGarbage,
              suggestionEndpoint: this.suggestionGarbageEndpoint,
              transformSuggestions: this.transformGarbageSuggestions
            }
          }, */
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          danger: {
            label: 'Класс опасности',
            required: true,
            disabled: true,
            placeholder: 'цифра',
            validationRulePattern: '^([1-5])$'
          },
          count: {
            label: 'Количество отходов, тонн',
            required: true
          },
          count_cubic: {
            label: 'Количество отходов, м<sup>3</sup>',
            required: true
          },
          organizationName: {
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название',
            label: 'Организация',
            suggestion: {
              options: [],
              onSelect: this.onSelectInputOrganization,
              suggestionEndpoint: this.suggestionOrganizationEndpoint,
              transformSuggestions: this.transformOrganizationSuggestions
            }
          }
        }
      },
      garbageOutputAttr () {
        return {
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          danger: {
            label: 'Класс опасности',
            required: true,
            disabled: true,
            placeholder: 'цифра',
            validationRulePattern: '^([1-5])$'
          },
          total: {
            label: 'Всего, тонн',
            required: true
          },
          total_cubic: {
            label: 'Всего, м<sup>3</sup>'
          },
          endOrganizationName: {
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название организации',
            label: 'Организация, которой переданы отходы',
            suggestion: {
              options: [],
              onSelect: this.onSelectOrganization,
              suggestionEndpoint: this.suggestionOrganizationEndpoint,
              transformSuggestions: this.transformOrganizationSuggestions
            }
          },
          tkoObjectName: {
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название объекта',
            label: 'Объект обращения, которому переданы отходы',
            suggestion: {
              options: [],
              onSelect: this.onSelectTKO,
              suggestionEndpoint: this.suggestionTKOEndpoint,
              transformSuggestions: this.transformTKOSuggestions
            }
          },
          use: {
            label: 'Передано для использования'
          },
          transportation: {
            label: 'Передано для транспортирования'
          },
          processing: {
            label: 'Передано на обработку'
          },
          utilization: {
            label: 'Передано на утилизацию'
          },
          neutralization: {
            label: 'Передано для обезвреживания'
          },
          storage: {
            label: 'Передано на хранение'
          },
          burial: {
            label: 'Передано на захоронение'
          }
        }
      },
      garbageDetailAttr () {
        return {
          morph_composition: {
            label: 'Морфологический состав',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            required: true
          },
          med_garbage_class_id: {
            label: 'Класс опасности',
            placeholder: 'цифра',
            required: true,
            validationRulePattern: '^([1-5])$',
            select: {
              options: this.medGarbageClass
            },
            transform: (model) => {
              return this.getMedGarbageClassLabel(model.med_garbage_class_id)
            }
          },
          formed: {
            label: 'Образовано'
          },
          utilization: {
            label: 'Утилизировано'
          },
          neutralization: {
            label: 'Обезврежено'
          },
          burial: {
            label: 'Захоронено'
          },
          storage: {
            label: 'Передано для транспортирования'
          },
          destroyed: {
            label: 'Уничтожено'
          }
        }
      },
      garbageDataUrl () {
        if (this.id) {
          let routeQuery = {
            query: {
              sourceId: this.id,
              year: this.year,
              type: this.operationType,
              garbage_type: 'med'
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }

          return garbage.garbageOperation(routeQuery)
        }
        // if new record, offline save
        return garbageOffline.medicalTable(this.$route.name, this.year, this.operationType)
      },
      medGarbageClass () {
        if (this.$store.getters.readUrlEndpoint(this.getMedGarbageClassEndpoint())) {
          return this.$store.getters.readUrlEndpoint(this.getMedGarbageClassEndpoint()).med_garbage_class
        }
        return []
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      getMedGarbageClassLabel (classId) {
        try {
          return this.medGarbageClass.find(v => v.id === classId).name
        } catch (e) {
          console.error(e.toString())
          return classId
        }
      },
      fetchData () {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getMedGarbageClassEndpoint(),
          fromCache: true
        })
      },
      getMedGarbageClassEndpoint () {
        return core.statuses({fields: 'med_garbage_class'})
      },
      letSearch () {
        this.search = JSON.parse(JSON.stringify(this.searchModel))
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          data.data[i].garbage_type = 'med'
        }
        // console.log(data.data)
        return data
      },
      garbagePostUrl (context, model) {
        return garbage.garbageOperationPost({
          query: {
            sourceId: this.id,
            year: this.year,
            type: this.operationType
          }
        })
      },
      garbagePatchUrl (context, model) {
        return garbage.garbageOperationPatch({
          query: {
            sourceId: model.id,
            year: model.year,
            type: this.operationType
          }
        })
      },
      garbageDeleteUrl (context, model) {
        return garbage.garbageOperationDelete({
          query: {
            sourceId: model.id,
            year: model.year,
            type: this.operationType
          }
        })
      },
      // afterValidate (ctx, model, errors, els) {
      //   let {tr} = els
      //   if (errors.danger) {
      //     delete errors.danger
      //     errors.fkkoName = 'Выберите отход'
      //   }
      //   if (errors.code) {
      //     delete errors.code
      //     errors.fkkoName = 'Выберите отход'
      //   }
      //
      //   if (errors.fkkoName) {
      //     this.focusOnField(tr, 'fkkoName')
      //   }
      //
      //   return errors
      // },
      onPaginate (paginationQuery) {
        this.paginationQuery = paginationQuery
      },
      onSortByField ({sort}) {
        this.sort = sort
      },
      onSelect (ctx, $event, model) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.code = copy.code
          model.fkko_id = copy.id
          model.fkkoName = copy.fkkoName
          model.fkko = {name: copy.fkkoName}
          model.danger = copy.danger
        } else {
          model.code = ''
          model.fkko_id = ''
          model.fkkoName = ''
          model.fkko = {name: ''}
          model.danger = ''
        }
      },
      onSelectGarbage (ctx, $event, model) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.garbage_source_input_id = copy.id
          model.garbageSourceName = this.$options.filters.stripHtml(copy.name)
        } else {
          model.garbage_source_input_id = ''
          model.garbageSourceName = ''
        }
      },
      onSelectInputOrganization (ctx, $event, model) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.organization_id = copy.id
          model.organizationName = this.$options.filters.stripHtml(copy.name)
        } else {
          model.organization_id = ''
          model.organizationName = ''
        }
      },
      onSelectOrganization (ctx, $event, model) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.tko_operator_id = copy.id
          model.endOrganizationName = this.$options.filters.stripHtml(copy.name)
        } else {
          model.tko_operator_id = ''
          model.endOrganizationName = ''
        }
      },
      suggestionEndpoint (ctx, q) {
        return cadastr.fkko({query: {q: q, 'per-page': 50}})
      },
      transformSuggestions (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].code + ' ' + data[i].name,
            fkkoName: data[i].name,
            id: data[i].id,
            code: data[i].code,
            danger: data[i].danger
          })
        }
        return options
      },
      addNewRowToMedicalTable () {
        const Model = () => {
          return {
            garbage_type: 'med',
            med_garbage_class_id: '',
            morph_composition: '',
            _operationType: JSON.parse(JSON.stringify(this.operationType)),
          }
        }
        if (this.operationType === 'detail') {
          this.$refs.detail.createRow(new Model())
        } else if (this.operationType === 'input') {
          this.$refs.input.createRow(new Model())
        } else if (this.operationType === 'output') {
          this.$refs.output.createRow(new Model())
        }
      }
    }
  }
</script>
